import { cloneDeep } from 'lodash';
import { DataViewSourceRecord } from '../../../sketch-editor/data-fetcher';

export interface RepeatableGraphicsTrackerData {
  hasChanges: (newFeatures?: DataViewSourceRecord[]) => boolean
}

const RepeatableGraphicsTracker = (initial: DataViewSourceRecord[]): RepeatableGraphicsTrackerData => {
  let previous = initial || [];

  const hasChanges = (newFeatures?: DataViewSourceRecord[]): boolean => {
    const oldFeatures = cloneDeep(previous);
    previous = cloneDeep(newFeatures) ?? [];

    if (oldFeatures.length !== newFeatures?.length) {
      return true;
    }

    const newFeaturesById = newFeatures.reduce((acc, feature) => {
      acc[feature.id] = feature;
      return acc;
    }, {} as DataViewSourceRecord);

    // Iterate through oldFeatures and compare geometry
    for (const oldFeature of oldFeatures) {
      const newFeature = newFeaturesById[oldFeature.id];
      if (!newFeature) {
        return true;
      }

      const oldGeometry = JSON.stringify({
        type: oldFeature?.geometry?.type,
        coordinates: oldFeature?.geometry?.coordinates,
      });

      const newGeometry = JSON.stringify({
        type: newFeature?.geometry?.type,
        coordinates: newFeature?.geometry?.coordinates,
      });

      if (oldGeometry !== newGeometry) {
        return true;
      }
    }

    return false;
  };

  return {
    hasChanges,
  };
};

export default RepeatableGraphicsTracker;
